import type { Tactic } from './types'

export const tactics: Tactic[] = [
  {
    id: 'T-Q2-01',
    quarter: 'Q2 2026',
    description: 'Release Matou Technology Blueprint',
    strategyId: 'open-source-ecosystem',
    owner: 'Team',
  },
  {
    id: 'T-Q2-02',
    quarter: 'Q2 2026',
    description: 'Refactor GitLab repos for public contribution (README, CONTRIBUTING.md, issue templates)',
    strategyId: 'open-source-ecosystem',
    owner: 'Team',
  },
  {
    id: 'T-Q2-03',
    quarter: 'Q2 2026',
    description: 'Finalise token/voucher design for Q4 launch',
    strategyId: 'token-economy',
    owner: 'Team',
  },
  {
    id: 'T-Q2-04',
    quarter: 'Q2 2026',
    description: 'Begin Elders Council outreach and relationship-building',
    strategyId: 'tikanga-governance',
    owner: 'Team',
  },
  {
    id: 'T-Q2-05',
    quarter: 'Q2 2026',
    description: 'Develop Matou Technologies learning programme (intro, use cases)',
    strategyId: 'community-validation',
    owner: 'Team',
  },
  {
    id: 'T-Q3-01',
    quarter: 'Q3 2026',
    description: 'Launch Matou MVP Community Infrastructure (data and website hosting)',
    strategyId: 'open-source-ecosystem',
    owner: 'Team',
  },
  {
    id: 'T-Q3-02',
    quarter: 'Q3 2026',
    description: 'Build web-based governance MVP (proposals, voting, treasury view) — off-chain',
    strategyId: 'open-source-ecosystem',
    owner: 'Team',
  },
  {
    id: 'T-Q3-03',
    quarter: 'Q3 2026',
    description: 'Build feedback mechanisms into the platform',
    strategyId: 'community-validation',
    owner: 'Team',
  },
  {
    id: 'T-Q3-04',
    quarter: 'Q3 2026',
    description: 'Test token/voucher system internally',
    strategyId: 'token-economy',
    owner: 'Team',
  },
  {
    id: 'T-Q4-01',
    quarter: 'Q4 2026',
    description: 'Launch MVP community platform (proposals, voting, treasury)',
    strategyId: 'open-source-ecosystem',
    owner: 'Team',
  },
  {
    id: 'T-Q4-02',
    quarter: 'Q4 2026',
    description: 'Launch token or voucher system',
    strategyId: 'token-economy',
    owner: 'Team',
  },
  {
    id: 'T-Q4-03',
    quarter: 'Q4 2026',
    description: 'Engage industry partners for collaboration and shared infrastructure',
    strategyId: 'open-source-ecosystem',
    owner: 'Team',
  },
  {
    id: 'T-2027-01',
    quarter: '2027+',
    description: 'Deploy mobile-accessible tools for low-connectivity communities',
    strategyId: 'community-validation',
    owner: 'Team',
  },
  {
    id: 'T-2027-02',
    quarter: '2027+',
    description: 'Formalise Elders Council with iwi/tribal group representation',
    strategyId: 'tikanga-governance',
    owner: 'Team',
  },
  {
    id: 'T-2027-03',
    quarter: '2027+',
    description: 'Evaluate on-chain deployment (Proof of Authority, Cardano partner chains)',
    strategyId: 'open-source-ecosystem',
    owner: 'Team',
  },
  {
    id: 'T-2027-04',
    quarter: '2027+',
    description: 'Grow contributor base through open-source community and industry partnerships',
    strategyId: 'community-validation',
    owner: 'Team',
  },
  {
    id: 'T-2027-05',
    quarter: '2027+',
    description: 'Develop full token economy (bonding curve, treasury distribution)',
    strategyId: 'token-economy',
    owner: 'Team',
  },
]

export const quarters = ['Q2 2026', 'Q3 2026', 'Q4 2026', '2027+'] as const
